<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.bandwidth_account_settings.card.message' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-text [fieldId]="'username'"></ziro-text>
      <ziro-text [fieldId]="'password'"></ziro-text>
      <ziro-text [fieldId]="'dlrAccountId'"></ziro-text>
      <ziro-text [fieldId]="'tlsVoiceAccountId'"></ziro-text>
      <ziro-select [fieldId]="'tlsVoiceEnvironmentType'"></ziro-select>
    </ziro-collapsible-section-card>

    <div class="alert alert-info refresh-alert">
      {{ 'tkey;admin.bandwidth_account_settings.refresh_card.message' | translate }}
      <br />
      @if (!isRefreshing) {
        <a class="strong cache-refresh-link" (click)="refreshCache()" target="_blank">
          <i [ngClass]="ziroIcons.REFRESH"></i>
          {{ 'tkey;admin.bandwidth_account_settings.refresh.link.text' | translate }}
        </a>
      }

      @if (isRefreshing) {
        <a class="strong text-warning disabled disabled-refresh-link" target="_blank">
          <i [ngClass]="ziroIcons.SAVING"></i>
          {{ 'tkey;admin.bandwidth_account_settings.refreshing.link.text' | translate }}
        </a>
      }
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
